import TransitionLink from 'app/components/pages/browse/TransitionLink'
import { BreadcrumbRoot } from 'components/ui/breadcrumb'

type Props = {
  items: { url: string; label: string }[]
  startTransition: (cb: () => void) => void
}

const CategoriesBreadcrumbs = ({ items, startTransition }: Props): JSX.Element => {
  return (
    <>
      <BreadcrumbRoot>
        {items.map((item) => (
          <TransitionLink key={item.url} href={item.url} startTransition={startTransition}>
            {item.label}
          </TransitionLink>
        ))}
      </BreadcrumbRoot>
    </>
  )
}

export default CategoriesBreadcrumbs
